import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CustomHttpClientService } from './custom-http-client.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DocumentService {

  url = environment.apiUrl;
  id = localStorage.getItem('residents');

  constructor(private http: CustomHttpClientService) { }


  uploadDocument(value: any, formState: boolean, fileChanged: any, documentId: any): Observable<any> {
    console.log(formState, fileChanged, documentId, 'value check point');
  
    // Create FormData object
    const Data = JSON.stringify(value);
    const formData: FormData = new FormData();
    formData.append('value', Data);
    formData.append('id', this.id);
    formData.append('documentId', documentId);
    formData.append('changed', fileChanged);
    formData.append('document', (value.file || null));
  
    // Conditional HTTP request
    if (formState) {
      // POST request for upload
      return this.http.post<any>(`${this.url}document/upload`, formData)
        .pipe(catchError(this.handleError));
    } else {
      // PUT request for update
      return this.http.put<any>(`${this.url}document/updateDocument`, formData)
        .pipe(catchError(this.handleError));
    }
  }
  
  getdocumentsByBuilding():Observable<any>{
    return this.http.get<any>(this.url+ 'document/getDocuments/?id='+this.id);
  }

  getAllDocuments():Observable<any>{
    return this.http.get(this.url+ 'document/getAllDocuments/?id='+this.id);
  }

  deleteDocument(id: any):Observable<any>{
    return this.http.delete<any>(this.url+ 'document/delete/?id='+ id);
  }

  getDocumentById(id: any):Observable<any>{
    return this.http.get<any>(this.url+ 'document/getDocumentById/'+id);
  }

  downloadFile(filePath: any):Observable<any>{
    return this.http.get<any>(this.url+ 'document/download/?path='+filePath);
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(error); // Return observable with error
  }

}
